import type { RootState } from 'store'

export const getFooter = (state: RootState) => state.footer
